import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNotifications } from '../../contexts/NotificationContext';
import NotificationItem from './NotificationItem';
import '../../styles/notifications/NotificationDropdown.css';

const NotificationDropdown = ({ onClose }) => {
  const {
    notifications,
    unreadCount,
    loading,
    markAllAsRead,
    loadNotifications,
  } = useNotifications();

  // Load notifications when dropdown opens - always bypass cache for fresh data
  // Only load on initial mount, not on every loadNotifications change
  useEffect(() => {
    loadNotifications({ limit: 20, _t: Date.now() });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty deps - only run on mount

  // Mark all as read when dropdown opens (optional - can be removed if not desired)
  useEffect(() => {
    if (unreadCount > 0) {
      // Don't auto-mark as read - let user do it manually
      // markAllAsRead();
    }
  // Run once on mount
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleMarkAllAsRead = async () => {
    try {
      await markAllAsRead();
    } catch (err) {
      console.error('Failed to mark all as read:', err);
    }
  };

  return (
    <div className="notification-dropdown">
      <div className="notification-dropdown-header">
        <h3>Notifications</h3>
        {unreadCount > 0 && (
          <button
            className="notification-mark-all-read"
            onClick={handleMarkAllAsRead}
          >
            Mark all as read
          </button>
        )}
      </div>

      <div className="notification-dropdown-content">
        {loading ? (
          <div className="notification-dropdown-loading">Loading...</div>
        ) : notifications.length === 0 ? (
          <div className="notification-dropdown-empty">
            <p>No notifications</p>
          </div>
        ) : (
          <div className="notification-dropdown-list">
            {notifications
              .slice(0, 10) // Show all notifications (read and unread)
              .map(notification => (
                <NotificationItem
                  key={notification.id}
                  notification={notification}
                  onClick={onClose}
                />
              ))}
          </div>
        )}
      </div>

      <div className="notification-dropdown-footer">
        <Link
          to="/notifications"
          className="notification-view-all"
          onClick={onClose}
        >
          View All Notifications
        </Link>
      </div>
    </div>
  );
};

export default NotificationDropdown;
